const riot = require('riot');

riot.tag2('page-companies', '<div class="s-full f"> <div data-is="module-sidebar"></div> <div class="s-full f fclm p40 bg-gray_light_10"> <div class="f fr mb20"><a class="button primary" href="/admin/companies/new">会社の新規登録</a></div> <div class="pt20 px20 pb4 bg-white"> <div class="f fm"> <label class="relative f fm w60per mr24"><i class="absolute t0 l8 b0 f fh material-icons fs24 text-gray_dark_20 mr10">search</i> <input class="input w-full pl40 pr24" ref="input" placeholder="企業名を入力" oninput="{debounceSearch}"><i class="absolute t0 r8 b0 f fh material-icons fs16 text-gray_dark_20 cursor-pointer" if="{refs.input.value}" onclick="{clearValue}">close</i> </label> </div> </div> <div class="s-full f fclm p20 bg-white overflow-hidden"> <div class="f fm py10 px16 border-bottom border-top border-gray_light_10 bg-primary_light_50"> <div class="w50per ts-h5">企業名</div> <div class="w50per ts-h5">残高(円)</div> </div> <div class="s-full overflow-scroll mb24"><a class="f fm lh14 py20 px16 hover-trigger hover-text-primary_dark_10 text-gray_dark_40 border-bottom border-gray_light_10" each="{company in companies}" href="/admin/companies/{company.id}"><span class="w50per">{company.name}</span><span class="w50per">{company.point_balance.toLocaleString()}</span></a></div> <div class="f fr mta mr20"> <div ref="pagination" data-is="atom-pagination" pagination="{pagination}"></div> </div> </div> </div> </div>', 'page-companies,[data-is="page-companies"]{display:block}', '', function(opts) {
    this.limit = 50;

    this.preload = () => {
      if (spat.isNode) return;
      app.utils.auth.validateOperator();
      this.fetchCompanies();
    };

    this.head = () => {
      return {
        title: app.utils.head.title('ダッシュボード', this),
      };
    };

    this.on('mount', () => {
      this.refs.pagination.on('paginationchange', (offset_type) => {
        this.changePagination(offset_type);
      });
    });

    this.debounceSearch = _.debounce(() => {
      try {
        this.fetchCompanies();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
    }, 512);

    this.changePagination = async (offset_type) => {
      var indicator = spat.modal.indicator();
      var offset = this.pagination[offset_type];
      var query = {
        offset,
      };
      try {
        await this.fetchCompanies(query);
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.fetchCompanies = async ({offset=0} ={}) => {
      var query = {
        offset,
        keyword: this.refs.input.value,
        limit: this.limit,
      };
      var companies_data = await app.api.child('companies').get(query);
      this.companies = companies_data.companies;
      this.pagination = companies_data.pagination;
      this.update();
    };

    this.clearValue = async () => {
      var indicator = spat.modal.indicator();
      this.refs.input.value = '';
      this.update();
      try {
        await this.fetchCompanies();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };
});